/**
 * Converts an ArrayBuffer to its hex string representation
 * @param {ArrayBuffer} buffer
 * @return {string}
 */
export function hex(buffer) {
    return Array.from(new Uint8Array(buffer))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join(``);
}

/**
 * Computes the SHA-256 digest of a string with Web Crypto
 * Source: https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
 * @param {string} str - string to hash
 * @return {Promise<string>} the sha256 hash of the string
 */
export async function sha256(str) {
    // Get the string as arraybuffer.
    const buffer = new TextEncoder().encode(str);

    // web
    if (crypto.subtle) {
        const hash = await crypto.subtle.digest('SHA-256', buffer);
        return hex(hash);
    }

    // nodejs
    return crypto.createHash('sha256').update(buffer).digest('hex');
}
